import { render, staticRenderFns } from "./PsiFormVerifySwitch.vue?vue&type=template&id=cac1d0e8&scoped=true&"
import script from "./PsiFormVerifySwitch.vue?vue&type=script&lang=js&"
export * from "./PsiFormVerifySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac1d0e8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VIcon,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cac1d0e8')) {
      api.createRecord('cac1d0e8', component.options)
    } else {
      api.reload('cac1d0e8', component.options)
    }
    module.hot.accept("./PsiFormVerifySwitch.vue?vue&type=template&id=cac1d0e8&scoped=true&", function () {
      api.rerender('cac1d0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormVerifySwitch.vue"
export default component.exports